export const breakpoints = {
  smallPhone: '320px',
  portraitPhone: '360px',
  landscapePhone: '480px',
  smallTablet: '600px',
  portraitTablet: '768px',
  landscapeTablet: '840px',
  smallLaptop: '1024px',
  laptop: '1280px',
  desktop: '1366px',
  hdDesktop: '1440px',
  fhdDesktop: '1920px'
};

export const breakpointsHeight = {
  smallPhone: '320px',
  landscapePhone: '360px',
  portraitPhone: '480px',
  smallLaptop: '600px',
  laptop: '768px',
  desktop: '840px',
  hdDesktop: '920px',
  fhdDesktop: '1280px'
};